export enum EditableParam {
  'finality' = 'finality',
  'amount' = 'amount',
  'instalment' = 'instalment',
  'duration' = 'duration'
}
